import { pluralPl } from '../../shared/polish-plural';

/**
 * Sound levels in words with the Polish decimal comma, as the map writes them
 * instead of the symbol „dB”: „1 decybel”, „62 decybele”, „60 decybeli”; a
 * fraction takes the genitive singular: „61,7 decybela”.
 *
 * Imports only shared/polish-plural.js: noise-monitoring-layer.test.mjs loads
 * both from source together with layers/NoiseMonitoringLayer.js.
 */

// Decimal places of a measured level (the measurement card and the tap card).
export const SOUND_LEVEL_FRACTION_DIGITS = 2;

function numberText(value, fractionDigits) {
    return Number(value).toLocaleString('pl-PL', {
        maximumFractionDigits: fractionDigits == null ? SOUND_LEVEL_FRACTION_DIGITS : fractionDigits,
    });
}

/** „61,7 decybela”, „62 decybele”, „60 decybeli”, „1 decybel”. */
export function decibelsLabel(value, fractionDigits) {
    const text = numberText(value, fractionDigits);
    const noun = text.indexOf(',') !== -1
        ? 'decybela'
        : pluralPl(Math.round(Number(value)), ['decybel', 'decybele', 'decybeli']);
    return text + ' ' + noun;
}

/**
 * A range reads „od … do …”, so the noun follows „do”: „48–72 decybeli”,
 * „48,5–72,3 decybela”.
 */
export function decibelRangeLabel(minimum, maximum, fractionDigits) {
    const high = numberText(maximum, fractionDigits);
    const noun = high.indexOf(',') !== -1 || Math.abs(Math.round(Number(maximum))) === 1 ? 'decybela' : 'decybeli';
    return numberText(minimum, fractionDigits) + '–' + high + ' ' + noun;
}

/**
 * A measured level: decibels („dB”, the unit of every published result, also
 * when it is missing) in words; any other unit as published.
 */
export function soundLevelLabel(value, unit, fractionDigits) {
    const symbol = unit == null ? '' : String(unit).trim();
    if (symbol !== '' && !/^db/i.test(symbol)) {
        return numberText(value, fractionDigits) + ' ' + symbol;
    }
    return decibelsLabel(value, fractionDigits);
}
